(function () {
    'use strict';

    var getUrlQuery = function(url, field) {
        var url = url ? url : window.location.href, 
            reg,
            queryString;
        if(field) {
            reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            try {
                queryString = reg.exec(url)[1];
            } catch(e) {
                queryString = null;
            }
            
        } else {
            queryString = url.substring(url.indexOf('?') + 1);
        }
        return queryString;
    };

    if (qidianMonitor) {
        window.__monitor = new qidianMonitor({
            projectName: 'qidian-wpa',
            uin: getUrlQuery(location.href, 'kfuin'),
            // 上报之前
            beforeReport: log => {
                console.log('beforeReport', log);
                // 增加script加载的文件进行收集
                try {
                    if (log.msg && (log.msg.indexOf('Script error') > -1)){
                        return false;
                    }
                    // 移除chrome插件的报错
                    if(log.msg && log.msg.indexOf('chrome-extension://')>-1){
                        return false;
                    }
                } catch (error) {
                    console.log('Script error',error);
                }
                return true // 返回true则进行上报，返回false则不进行上报
            },
            // 上报之后
            afterReport: log => {
                // console.log('afterReport', log)
            },
            // 上报测速之前
            beforeReportSpeed: log => {
                // console.log('beforeReportSpeed', log)
                return log;
            },
            // 发送请求之前，可以改变上报内容，必须返回需要上报的内容，否则会阻止上报
            beforeRequest: log => {
                // console.log('beforeRequest', log)
                return log;
            },
            // 针对某监控平台特殊的钩子, 该钩子就只会给RUM执行
            rumBeforeRequest: log => {
                // console.log('beforeRequest', log)
                return log;
            }
        });
    }
    function rumReport(data) {
        if (!window.__monitor) {
            return;
        }
        const monitorDataArray = Object.keys(data) || [];
        const resultParams = monitorDataArray.map(key => (`${key}=${data[key]}`));
        const arr = data.message && data.message.split(/-/ig);
        if (arr && arr.length > 1) {
            window.__monitor.customerReport({
                name: arr[0] + '&kfuin=' + data.kfuin,
                ext1: arr[1],
                ext2: arr[2]
            });
        } else {
            window.__monitor.log(resultParams.join('&'));
        }
    }

    function addEvent(elem, eventName, callbackFunction) {
        if(elem.addEventListener) {
            elem.addEventListener(eventName, callbackFunction, false);
        } else {
            elem.attachEvent('on' + eventName, callbackFunction);
        }
    }

    var postMsgFilter = function(postMsg) {
        var regex = /uc_msg|oppo_night|weibo|msfapi|axure/i,
            _toString = Object.prototype.toString, //{"UC_MSG_NAME":"UCBROWSER_GET_VIDEO_URL"|{"type":"oppo_night","action":"removeNightMode"}}
            postMsgUrl;

        try {
            postMsgUrl = _toString.call(postMsg) == '[object String]' && JSON.parse(postMsg).ldpUrl;
            if(regex.test(postMsgUrl)) {
                return postMsg;
            }
        } catch(e) {
            console.error('PostMsg Parse Error ' + postMsg);
        }
            

        if(!postMsg || _toString.call(postMsg) !== '[object String]' || regex.test(postMsg)) {
            return false;
        }
        return postMsg;
    };

    var postMsg = (function() {
        var msgData,
            flagKey = 'QD_PM',
            flagVal = 'CHAT';
        function receive(target, cb) {
            addEvent(target, 'message', function(e) {
                var postMsg = postMsgFilter(e.data);
                if(postMsg) {
                    // postMsg.indexOf(flagKey) == -1 && BJ_REPORT && BJ_REPORT.report('PM NO Flag ' + postMsg);
                    try {
                        msgData = JSON.parse(postMsg);
                    } catch(e) {
                        console.error('PostMsg Parse Error ' + postMsg);
                    }
                    typeof cb == 'function' ? cb(msgData) : '';
                } else {
                    return;
                }
            });
        }
        function send(postMsgData, sendFlagVal) {
            var sendData = msgData ? $.extend(msgData, postMsgData) : postMsgData;
            var _flagVal = sendFlagVal || flagVal;
            if(!sendData.hasOwnProperty(flagKey) || sendData[flagKey] != _flagVal) {
                sendData[flagKey] = _flagVal;
            }
            sendData = typeof sendData != 'string' ? JSON.stringify(sendData) : sendData;
            window.parent.postMessage(sendData, '*');
        }
        return {
            receive: receive,
            send: send
        }
    })();

    /**
     * @fileOverview
     * @author amoschen
     * @version 1
     * Created: 12-8-27 下午8:26
    */
    var doc = document;
    /**
     * Cookie utilities
     * @class Cookie
     * @namespace util
     * @module util
     */
    /**
     * Set a cookie item
     * @method set
     * @static
     * @param {String} name Cookie name
     * @param {*} value Cookie value
     * @param {String} [domain=fullDomain] The domain cookie store in
     * @param {String} [path=currentPath] The path cookie store in
     * @param {Date} [expires=sessionTime] The expire time of cookie
     * @chainable
     */
    function setCookie(name, value, domain, path, expires){
        if(expires){
            expires = new Date(+new Date() + expires);
        }

        var tempcookie = name + '=' + escape(value) +
            ((expires) ? '; expires=' + expires.toGMTString() : '') +
            ((path) ? '; path=' + path : '') +
            ((domain) ? '; domain=' + domain : '');

        //Ensure the cookie's size is under the limitation
        if(tempcookie.length < 4096) {
            doc.cookie = tempcookie;
        }

        return this;
    }
    /**
     * Get value of a cookie item
     * @method get
     * @static
     * @param {String} name Cookie name
     * @return {String|Null}
     */
    function getCookie(name){
        var carr = doc.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
        if (carr != null){
            return unescape(carr[2]);
        }

        return null;
    }

    /**
     * local memory db
     * refer:https://github.com/bevacqua/local-storage/blob/master/stub.js
     */
    var memorydb = function() {
        var ms = {};
        function getItem(key){
            return key in ms ? ms[key] : false;
        }
        function setItem(key, value) {
            ms[key] = value;
            return true;
        }
        function removeItem(key) {
            var found = key in ms;
            if(found) {
                return delete ms[key];
            } else {
                return false;
            }
        }
        function clear() {
            ms = {};
            return true;
        }
        return {
            type: 'memory',
            getItem,
            setItem,
            removeItem,
            clear
        }
    };

    var isInIframe = (function() {
        return window.parent == window ? false : true;
    })();

    var globalVars = {
        win: window,
        receptionist: {},
        wpaDetail: {
            // instant上线需要的配置信息 会在wpa postmessage过来
            WPA_LOGIN_CONFIG: {}
        },
        isInIframe: isInIframe,
        seqs: {
            key: '',
            data: [],
        },
        // 第三方应用信息
        thirdAppConfig: {
            enable: false,
            type: '', // wx_mp-微信公众号 wx_mini-微信小程序 31-31
            appType: 0, // appType 1: wx; 2: qq; 3: 31;
            appId: '',
            openId: '',
            userInfo: null, // 第三方用户信息
        }
    };
    var userAgent = globalVars.win.navigator.userAgent.toLocaleLowerCase();
    globalVars.userAgent = userAgent;

    var msgdb = (function(global) {
        var ls = memorydb();
        const QUOTA_EXCEEDED_ERR_CODE = 22;
        try {
            if('localStorage' in global && global.localStorage) {
                global.localStorage.setItem("test", "test");
                global.localStorage.removeItem("test");
                ls = global.localStorage;
            }
        } catch(e) {
            // BJ_REPORT && BJ_REPORT.report(JSON.stringify(e));
        }
        function get(key){
            return ls.getItem(key);
        }
        function set(key, value) {
            let flag = false;
            try {
              ls.setItem(key, value);
              flag = true;
            } catch (e) {
              console.log('消息写入缓存失败: ', e, e.code);
              flag = false;
              // localStorage写满处理
              if (QUOTA_EXCEEDED_ERR_CODE === e.code) {
                let { key: seqKey, data: seqData } = globalVars.seqs;
                const INDEX_KEY = `${seqKey.substring(0, seqKey.length - 4)}index`;
                do {
                    // 取出前一半key进行删除
                    const halfCount = Math.round(seqData.length / 2);
                    // 截取要删除的seq
                    const delSeqs = seqData.splice(0, halfCount);
                    delSeqs.forEach(s => remove(`${INDEX_KEY}${s}`));
                    // 尝试插入
                    try {
                        ls.setItem(key, value);
                        // 插入成功后置操作
                        flag = true;
                        // 更新缓存中的seqs数组
                        ls.setItem(seqKey, JSON.stringify(seqData));
                        // 同时需要更新历史或者跨屏同步数据
                        const { kfUin, visitorId } = globalVars.receptionist;
                        const historyKey = `kf${kfUin}`;
                        const historyCounts = JSON.parse(ls.getItem(historyKey)) || [];
                        for (let i = 0; i < historyCounts.length; i++) {
                            const element = historyCounts[i];
                            if (element.visitorId === visitorId) {
                                element.total = seqData.length;
                                break;
                            }
                        }
                        ls.setItem(historyKey, JSON.stringify(historyCounts));
                    } catch (error) {
                        console.log('缓存尝试插入失败，继续删除重试！');
                        flag = false;
                    }
                } while (!flag);
              }
            }
            return flag;
        }
        function remove(key) {
            return ls.removeItem(key);
        }
        function clear() {
            return ls.clear();
        }

        return {
            type: ls.type,
            get,
            set,
            remove,
            clear
        }
    })(window);

    /**
     * 从URL,Cookie,LocalStorage里读取visitorId或者新建visitorId
     * @param {Object} fromURL 是否从URL里读取，以及URL
     * @param {string} fromURL.active 是否从URL里读取
     * @param {string} fromURL.url url地址
     */
    function getVisitorId(fromURL) {
        var key = 'tencentSig',
            visitorId,
            isLocalStorageSupported = (typeof msgdb.type === 'undefined' || msgdb.type === 'memory') ? true : false;
        if(globalVars.thirdAppConfig.secretKey){
            key = 'tencentThirdSig';
        }
        var _fromURL = {
            active: false,
            url: ''
        };
        $.extend(_fromURL, fromURL);
        function get() {
            //  URL 优先级第一 cookie优先级第二，兼容旧版本
            var active = _fromURL.active,
                url = _fromURL.url;
            var visitorId = active ? getUrlQuery(url, 'visitorId') : getCookie(key);
            if(!/^\d+$/.test(visitorId)) {
                visitorId = '';
            }
            if (!active && isLocalStorageSupported) { //  URL来的不需要复制
                if (!visitorId) {
                    visitorId = msgdb.get(key);
                    if(!/^\d+$/.test(visitorId)) {
                        visitorId = '';
                    }
                } else {
                    //复制cookie里面的数据到localstorage
                    msgdb.set(key, visitorId);
                }
            }

            return visitorId;
        }
        function set() {
            var tmpVisitorId = (Math.floor(Math.random() * 10) || 1) + _uuid(3, 10) + new Date().getTime().toString().slice(2, 13);
            if (isLocalStorageSupported) {
                msgdb.set(key, tmpVisitorId);
            } else {
                setCookie(key, tmpVisitorId, null, '/', 31536000000);
            }
            return tmpVisitorId;
        }
        visitorId = get();
        if (!visitorId) {
            visitorId = set();
        }
        return visitorId;
    }

    function _uuid(len, radix) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [], i;
        radix = radix || chars.length;
        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
        } else {
            // rfc4122, version 4 form
            var r;
            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';
            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        return uuid.join('');
    }

    function pageVisibility() {
        var _isHidden = undefined;
        var customEvent = null;
        var _isIE = function(version) {
            var b = document.createElement('b');
            b.innerHTML = '<!--[if IE '+ version +']><i></i><![endif]-->';
            return b.getElementsByTagName('i').length === 1;
        };

        var isIE = _isIE();
        var isIE9 = _isIE(9);
        var prefixSupport = isIE9 ? '' : null, 
            keyWithPrefix = function(prefix, key) {
                if (prefix !== "") {
                    // 首字母大写
                    return prefix + key.slice(0,1).toUpperCase() + key.slice(1);    
                }
                return key;
            };

        var isPageVisibilitySupport = (function() {
            var support = false;
            if (typeof window.screenX === "number") {
                ["webkit", "moz", "ms", "o", ""].forEach(function(prefix) {
                    if (support == false && document[keyWithPrefix(prefix, "hidden")] != undefined) {
                        prefixSupport = prefix;
                        support = true;   
                    }
                });        
            }
            return support;
        })();
        
        if(isIE && !isPageVisibilitySupport) {
            if(document.addEventListener) {
                window.addEventListener('focus', onFocus, true);
                window.addEventListener('blur', onBlur, true);
            } else {
                document.attachEvent('onfocusin', onFocus);
                document.attachEvent('onfocusout', onBlur);
            }
            if(typeof document.createEvent !== 'undefined' && !customEvent) {
                customEvent = document.createEvent('HTMLEvents');
                customEvent.initEvent('visibilitychange', true, true);
            } else {
                document.documentElement.visibilitychange = 0; //IE8
            }
        }

        function onFocus() {
            _isHidden = false;
            if(isIE9) {
                document.dispatchEvent(customEvent);
            } else {
                document.documentElement.visibilitychange = 1;
            }
        }

        function onBlur() {
            _isHidden = true;
            if(isIE9) {
                document.dispatchEvent(customEvent);
            } else {
                document.documentElement.visibilitychange = 0;
            }
        }

        var isHidden = function() {
            if (isPageVisibilitySupport) {
                return document[keyWithPrefix(prefixSupport, "hidden")];
            } else if(typeof(_isHidden) !== 'undefined') {
                return _isHidden;
            }
            return undefined;
        };
        
        var visibilityState = function() {
            if (isPageVisibilitySupport) {
                return document[keyWithPrefix(prefixSupport, "visibilityState")];
            } else if(typeof(_isHidden) !== 'undefined') {
                return _isHidden ? 'hidden' : 'visible';
            }
            return undefined;
        };
        return {
            hidden: isHidden(),
            isHidden: isHidden,
            isPageVisibilitySupport: isPageVisibilitySupport,
            visibilityState: visibilityState(),
            visibilitychange: function(fn, usecapture) {
                usecapture = false;
                if(typeof fn === "function") {
                    if(isPageVisibilitySupport || isIE9) {
                        return document.addEventListener(prefixSupport + "visibilitychange", function(evt) {
                            fn.call(this, evt, isHidden(), visibilityState());
                        }, usecapture);
                    } else {
                        document.documentElement.attachEvent("onpropertychange", function(evt) {
                            if (event.propertyName == "visibilitychange") {
                                fn.call(this, evt, isHidden(), visibilityState());
                            }
                        });                    
                    }
                }
                return undefined;
            }
        };    
    }

    var createRandomId = function () {
        var chars = '0123456789',
            randomId = [], i;

        randomId[0] = (0 | Math.random() * 10) || 1;

        for (i = 1; i < 4; i++) {
            randomId[i] = chars[0 | Math.random() * 10];
        }

        return randomId.join('') + new Date().getTime().toString().slice(2, 13)
    };
    //生成32位uuid
    var createUuid32 = function () {
        return 'xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    const isOa = /^oa.*/.test(location.host);

    const COMP_CONF = {
      // 在线离线appid
      appid: 6,
      ws: isOa ? 'https://testwss.qidian.qq.com' : 'https://wpa.mango.qidian.qq.com',
      heartbeat: 3*60,
      CGI_URL: function() {
        const domain = ` https://${isOa ? 'test' : ''}gateway.qidian.qq.com`;
        return {
          SOCKET_CHAT: (!!window.WebSocket && window.WebSocket.prototype.send) ? `https://${__domain.chat}` : 'https://pollingchat.qidian.qq.com',
          COMP_SOURCE_URL: `https://${__domain.source}.com/qidian/chatClient/release/comp/`,
          GET_MSG_DISPLAYED: `${domain}/v1/wpaVisitor/getMsgDisplayed`,
          autotInviteConf: `${domain}/v1/wpaVisitor/getInviteConf`,
          refuseInvite: `${domain}/v1/wpaVisitor/refuseInvite`,
          socketLoginConfig: `${domain}/v1/interface/inner/cloudim_324034`,
          POST_MSG_DISPLAYED: `${domain}/v1/wpaVisitor/displayMessageOnC`,
          bindWpaAndImAid: `${domain}/v1/wpaVisitor/aidBind`
        }
      }(),
      /**
         * 是否为链接型WPA
         */
      isLinkWPA: function () {
        var pageURL = window.location.href,
            isLinkWPA = getUrlQuery(pageURL, 'linkType'),
            visitorId = getUrlQuery(pageURL, 'visitorId'),
            isInIframe = window.parent == window ? false : true;
        visitorId && visitorId.length > 0 ? isLinkWPA = 1 : ''; //兼容呼起手Q中转页网页咨询传递的参数
        if (isLinkWPA && (''+isLinkWPA).length > 0 && !isInIframe) {
            return true;
        }
        return false;
      }(),
      SOCKET_OPTS: {
        OPTS: {
          path: '/session',
          reconnectionDelay: 10000,
          reconnectionDelayMax: 20000, // 设置创建连接所接收的超时时间，单位是毫秒
          reconnectionAttempts: 2,
          timeout: 20000,
          transports: ['websocket'],
          // 'transports': ['websocket', 'xhr-multipart', 'xhr-polling', 'jsonp-polling', 'flashsocket', 'htmlfile']
        },
        C2B_TIMEOUT: 60000, // c2b消息超时时间从4秒改为1分钟
        SIGT_TIMEOUT: 10000, // 调整到10秒。
        REG_TIMEOUT: 60000,
        SEQ_RANGE: {
          C2B_FOR_PHP: 2147483647,
          C2B_FOR_PC: 65535,
        },
        CLIENT_PING_DELAY: 20000,
        MAX_FAIL_TIMES: 2, // 最大连接失败重试次数。这里指的是因为server拒绝而连接失败。
      },

      /**
         * socket 命令
         */
      SOCKET_CMD: {
        REG: {
          EMIT: 'register',
          RECEIVE: 'register ack',
        },
        C2B: {
          EMIT: 'message c2b',
          RECEIVE: 'message c2b ack',
        },
        B2C: {
          RECEIVE: 'message b2c',
          EMIT: 'message b2c ack',
        },
        KF_CHANGE: {
          EMIT: 'change kf',
          RECEIVE: 'change kf ack',
        },
        ROUTE: {
          RECEIVE: 'route change',
          EMIT: 'route change ack',
        },
        OVER: {
          RECEIVE: 'session over',
        },
        SESSION_MSG: {
          RECEIVE: 's_msg',
          EMIT: 's_msg_ack',
        },
        CLIENT_PING: {
          EMIT: 'p',
        },
        INITVIDEO: {
          EMIT: 'rtc_create_room',
          RECEIVE: 'rtc_create_room_ack',
        },
        ROOMINFO: {
          EMIT: 'rtc_get_room',
          RECEIVE: 'rtc_get_room_ack',
        },
        VIDEOEVENT: {
          EMIT: 'rtc_event_report',
          RECEIVE: 'rtc_event_report_ack',
        },
        VIDEOSTATUS: {
          EMIT: 'rtc_status_report',
          RECEIVE: 'rtc_status_report_ack',
        },
        VIDEOPING: {
          EMIT: 'rtc_health_check',
          RECEIVE: 'rtc_health_check_ack',
        },
        VIDEOSMSG: {
          RECEIVE: 'rtc_s_msg',
          EMIT: 'rtc_s_msg_ack',
        },
        // C侧结束会话
        SESSION_END: {
          EMIT: 'session_end',
          RECEIVE: 'session_end_ack',
        },
        // 屏幕共享
        SCREEN_SHARE: {
          EMIT: 'rtc_screen_share',
          RECEIVE: 'rtc_screen_share_ack',
        },
      },
    };

    function postMsgSender(msgData) {
        msgData && postMsg.send(msgData, 'ONLINE_STATUS');
    }

    /**
     *  base64.ts
     *
     *  Licensed under the BSD 3-Clause License.
     *    http://opensource.org/licenses/BSD-3-Clause
     *
     *  References:
     *    http://en.wikipedia.org/wiki/Base64
     *
     * @author Dan Kogai (https://github.com/dankogai)
     */
    const _hasatob = typeof atob === 'function';
    const _hasbtoa = typeof btoa === 'function';
    const _hasBuffer = typeof Buffer === 'function';
    const _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
    const _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
    const b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    const b64chs = Array.prototype.slice.call(b64ch);
    const b64tab = ((a) => {
        let tab = {};
        a.forEach((c, i) => tab[c] = i);
        return tab;
    })(b64chs);
    const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
    const _fromCC = String.fromCharCode.bind(String);
    const _U8Afrom = typeof Uint8Array.from === 'function'
        ? Uint8Array.from.bind(Uint8Array)
        : (it) => new Uint8Array(Array.prototype.slice.call(it, 0));
    const _mkUriSafe = (src) => src
        .replace(/=/g, '').replace(/[+\/]/g, (m0) => m0 == '+' ? '-' : '_');
    const _tidyB64 = (s) => s.replace(/[^A-Za-z0-9\+\/]/g, '');
    /**
     * polyfill version of `btoa`
     */
    const btoaPolyfill = (bin) => {
        // console.log('polyfilled');
        let u32, c0, c1, c2, asc = '';
        const pad = bin.length % 3;
        for (let i = 0; i < bin.length;) {
            if ((c0 = bin.charCodeAt(i++)) > 255 ||
                (c1 = bin.charCodeAt(i++)) > 255 ||
                (c2 = bin.charCodeAt(i++)) > 255)
                throw new TypeError('invalid character found');
            u32 = (c0 << 16) | (c1 << 8) | c2;
            asc += b64chs[u32 >> 18 & 63]
                + b64chs[u32 >> 12 & 63]
                + b64chs[u32 >> 6 & 63]
                + b64chs[u32 & 63];
        }
        return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
    };
    /**
     * does what `window.btoa` of web browsers do.
     * @param {String} bin binary string
     * @returns {string} Base64-encoded string
     */
    const _btoa = _hasbtoa ? (bin) => btoa(bin)
        : _hasBuffer ? (bin) => Buffer.from(bin, 'binary').toString('base64')
            : btoaPolyfill;
    const _fromUint8Array = _hasBuffer
        ? (u8a) => Buffer.from(u8a).toString('base64')
        : (u8a) => {
            // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
            const maxargs = 0x1000;
            let strs = [];
            for (let i = 0, l = u8a.length; i < l; i += maxargs) {
                strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
            }
            return _btoa(strs.join(''));
        };
    // This trick is found broken https://github.com/dankogai/js-base64/issues/130
    // const utob = (src: string) => unescape(encodeURIComponent(src));
    // reverting good old fationed regexp
    const cb_utob = (c) => {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (_fromCC(0xc0 | (cc >>> 6))
                    + _fromCC(0x80 | (cc & 0x3f)))
                    : (_fromCC(0xe0 | ((cc >>> 12) & 0x0f))
                        + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                        + _fromCC(0x80 | (cc & 0x3f)));
        }
        else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (_fromCC(0xf0 | ((cc >>> 18) & 0x07))
                + _fromCC(0x80 | ((cc >>> 12) & 0x3f))
                + _fromCC(0x80 | ((cc >>> 6) & 0x3f))
                + _fromCC(0x80 | (cc & 0x3f)));
        }
    };
    const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    /**
     * @deprecated should have been internal use only.
     * @param {string} src UTF-8 string
     * @returns {string} UTF-16 string
     */
    const utob = (u) => u.replace(re_utob, cb_utob);
    //
    const _encode = _hasBuffer
        ? (s) => Buffer.from(s, 'utf8').toString('base64')
        : _TE
            ? (s) => _fromUint8Array(_TE.encode(s))
            : (s) => _btoa(utob(s));
    /**
     * converts a UTF-8-encoded string to a Base64 string.
     * @param {boolean} [urlsafe] if `true` make the result URL-safe
     * @returns {string} Base64 string
     */
    const encode = (src, urlsafe = false) => urlsafe
        ? _mkUriSafe(_encode(src))
        : _encode(src);
    // This trick is found broken https://github.com/dankogai/js-base64/issues/130
    // const btou = (src: string) => decodeURIComponent(escape(src));
    // reverting good old fationed regexp
    const re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    const cb_btou = (cccc) => {
        switch (cccc.length) {
            case 4:
                var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                    | ((0x3f & cccc.charCodeAt(1)) << 12)
                    | ((0x3f & cccc.charCodeAt(2)) << 6)
                    | (0x3f & cccc.charCodeAt(3)), offset = cp - 0x10000;
                return (_fromCC((offset >>> 10) + 0xD800)
                    + _fromCC((offset & 0x3FF) + 0xDC00));
            case 3:
                return _fromCC(((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    | (0x3f & cccc.charCodeAt(2)));
            default:
                return _fromCC(((0x1f & cccc.charCodeAt(0)) << 6)
                    | (0x3f & cccc.charCodeAt(1)));
        }
    };
    /**
     * @deprecated should have been internal use only.
     * @param {string} src UTF-16 string
     * @returns {string} UTF-8 string
     */
    const btou = (b) => b.replace(re_btou, cb_btou);
    /**
     * polyfill version of `atob`
     */
    const atobPolyfill = (asc) => {
        // console.log('polyfilled');
        asc = asc.replace(/\s+/g, '');
        if (!b64re.test(asc))
            throw new TypeError('malformed base64.');
        asc += '=='.slice(2 - (asc.length & 3));
        let u24, bin = '', r1, r2;
        for (let i = 0; i < asc.length;) {
            u24 = b64tab[asc.charAt(i++)] << 18
                | b64tab[asc.charAt(i++)] << 12
                | (r1 = b64tab[asc.charAt(i++)]) << 6
                | (r2 = b64tab[asc.charAt(i++)]);
            bin += r1 === 64 ? _fromCC(u24 >> 16 & 255)
                : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255)
                    : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
        }
        return bin;
    };
    /**
     * does what `window.atob` of web browsers do.
     * @param {String} asc Base64-encoded string
     * @returns {string} binary string
     */
    const _atob = _hasatob ? (asc) => atob(_tidyB64(asc))
        : _hasBuffer ? (asc) => Buffer.from(asc, 'base64').toString('binary')
            : atobPolyfill;
    //
    const _toUint8Array = _hasBuffer
        ? (a) => _U8Afrom(Buffer.from(a, 'base64'))
        : (a) => _U8Afrom(_atob(a).split('').map(c => c.charCodeAt(0)));
    //
    const _decode = _hasBuffer
        ? (a) => Buffer.from(a, 'base64').toString('utf8')
        : _TD
            ? (a) => _TD.decode(_toUint8Array(a))
            : (a) => btou(_atob(a));
    const _unURI = (a) => _tidyB64(a.replace(/[-_]/g, (m0) => m0 == '-' ? '+' : '/'));
    /**
     * converts a Base64 string to a UTF-8 string.
     * @param {String} src Base64 string.  Both normal and URL-safe are supported
     * @returns {string} UTF-8 string
     */
    const decode = (src) => _decode(_unURI(src));

    if (!isOa) {
        try {
            // 客户不希望控制台有日志
            console.log = function () { };
            console.info = function () { };
        } catch (ex) {}
    }

    let socketio = null;
    let recepitionDetailForUnread = {};
    const SOCKET_NOTIFY = {
        UNREAD_MSG: 140, // 新webim在线访客上线未读消息数推送
        DISPLAY_MSG: 141, // 新webim在线访客消息回显id推送
        INVITE: 142  // 新webim在线访客， 手动邀请访客推送
    };
    const reciveSocketMsgMap = {
        [SOCKET_NOTIFY.UNREAD_MSG]: {
            DATA_KEY: 'msg_visitor_unread_msg_notify',
            handler: offlineMsgNumListener,
        },
        [SOCKET_NOTIFY.DISPLAY_MSG]: {
            DATA_KEY: 'msg_visitor_display_msg_notify',
            handler: displayListener,
        },
        [SOCKET_NOTIFY.INVITE]: {
            DATA_KEY: 'msg_visitor_invite_notify',
            handler: invitationListener,
        }
    };
    /**
        * 离线数目监听
    */
    function offlineMsgNumListener(data) {
        var sendData = data,
            recepitionDetailKey = 'kfuin' + sendData.kfuin;
        // if(sendData.msgNum > 0) {
        sendData['number'] = sendData.msgNum || 0;
        delete sendData.seq;
        delete sendData.msgNum;
        console.log('msg_visitor_unread_msg_notify', sendData);
        if(typeof sendData.receptionName !== 'undefined') {
            recepitionDetailForUnread[recepitionDetailKey] = sendData.receptionName;
        } else {
            sendData.receptionName = recepitionDetailForUnread.hasOwnProperty(recepitionDetailKey) ? recepitionDetailForUnread[recepitionDetailKey] : null;
        }
        postMsgSender({
            act: 'SM_UNREAD',
            kfuin: sendData.kfuin,
            data: sendData
        });
        
    }
     /**
        * 消息外显监听
    */
     function displayListener(data){
        var sendData = data,
            recepitionDetailKey = 'kfuin' + sendData.kfuin;
        delete sendData.seq;
        if(typeof sendData.receptionName !== 'undefined') {
            recepitionDetailForUnread[recepitionDetailKey] = sendData.receptionName;
        } else {
            sendData.receptionName = recepitionDetailForUnread.hasOwnProperty(recepitionDetailKey) ? recepitionDetailForUnread[recepitionDetailKey] : null;
        }
        sendData.kfuin= globalVars.wpaDetail.kfuin;
        const { WPA_LOGIN_CONFIG } = globalVars.wpaDetail;
        var postData = {
            act: 'SM_DISPLAY',
            data: { 
                ...sendData,
                aid: WPA_LOGIN_CONFIG.aid,
                d2: WPA_LOGIN_CONFIG.d2,
                appid: COMP_CONF.appid,
            },
            kfuin: sendData.kfuin,
            
        };
        postMsgSender(postData);
    }
    /**
        * 手动会话邀请监听
    */
    function invitationListener(data) {
        var kfuin = data.kfuin;
        delete data.kfuin;
        postMsgSender({
            act: 'SM_MANUAL_INVITE',
            kfuin: kfuin,
            data: data
        });
    }

    // 初始化instant
    function initInstant(params) {
        const { kfuin } = params;
        const { WPA_LOGIN_CONFIG } = globalVars.wpaDetail;
        const socketParams = {
            kfuin: kfuin, // 主号,
            aid: WPA_LOGIN_CONFIG.aid, // mango需要主号维度
            d2: WPA_LOGIN_CONFIG.d2, // IM消息系统校验token
            url: COMP_CONF.ws, // APEX网关地址
            appid: COMP_CONF.appid, // 产品类型(向天机ST申请)
            token_type: 0,        // 固定
            skey: '',             // 留空
            client_type: 5, // web工作台: 5 移动端web工作台: 7
            userdefine: JSON.stringify(params),
            // 以秒为单位
            heartbeat: COMP_CONF.heartbeat
        };
        socketio = Instant.create(socketParams);
        socketio.ready().then((info) => {
            console.log("Instant Ready", info);
        });
        socketio.on(Instant.NOTIFY_MESSAGE_TYPE.NOTIFY_NEW_SC_MESSAGE, result => {
            const sc_message_array = result;
            for (const sc of sc_message_array) {
                const subMsgType = sc['uint32_sub_msgtype'];
                const subCommand = sc['uint32_sub_command'];
                const scData = JSON.parse(sc['bytes_sc_data']);
                console.log('receiveTRC', subMsgType, subCommand, scData);
                if (subMsgType === 0x210 && subCommand === 0x92) {
                    const uint32_sub_cmd = scData['uint32_sub_cmd'];

                    const map = reciveSocketMsgMap[uint32_sub_cmd];
                    const data = scData[map.DATA_KEY];
                    if(map) {
                        // 服务端返回的格式都是unit或者str开头的，为了减少wpa修改量，这里替换下
                        let newData = {};
                        Object.keys(data).forEach(k => {
                            let val = data[k],
                                newk = k.replace(/^((str)|(uint)).*?_/ig, '');
                            newData[newk] = val;
                        });
                        map && map.handler(newData);
                    }
                }
            }
        });

        socketio.on(Instant.NOTIFY_MESSAGE_TYPE.ERROR, (error) => {
            console.log("Instant Error", error);
        });
    }

    // 接口文档 https://iwiki.woa.com/pages/viewpage.action?pageId=4007862877
    let maxReTryTime = 3;

    // 去掉属性中的类型
    function formatTypeObj(data) {
        const ret = {};
        Object.keys(data).forEach(k => {
            let val = data[k],
                newk = k.replace(/^((str)|(uint)).*?_/ig, '');
                ret[newk] = val;
        });
        return ret;
    }

    // 拉取自动邀请配置下发cgi
    function autotInviteConf(data, callback) {
        const { kfuin, isMobile} = data;
        const visitorId = data.WPA_LOGIN_CONFIG.aid;
        $.ajax({
            url: `${COMP_CONF.CGI_URL.autotInviteConf}?kfuin=${kfuin}`,
            data: JSON.stringify({
                kfuin,
                isMobile,
                visitorId
            }),
            type: 'POST',
            timeout: 5000,
            dataType: 'json',
            contentType: 'application/json;charset=UTF-8',
            success: function (res) {
                if (res.code === 0) {
                    const data = res.data;

                    if (typeof callback === 'function') {
                        callback(data);
                    }

                    postMsgSender({
                        act: 'SM_INVITE_CONF',
                        kfuin: res.data.kfuin,
                        inviteRule: data
                    });
                    data.unReadMsg && offlineMsgNumListener(formatTypeObj(data.unReadMsg));
                    data.displayMsg && displayListener(formatTypeObj(data.displayMsg));
                } else {
                    rumReport({
                        message: `imwpa:访客获取自动邀请配置失败-result=${JSON.stringify(res)}`,
                        kfuin: kfuin,
                    });
                }
            },
            error: function (err) {
                console.log('err invite', err);

                if (typeof callback === 'function') {
                    // 如果请求失败了 就返回默认值 手动邀请未开
                    callback({
                        manualInviteSwitch: 2, // 1--开启 2--关闭
                    });
                }
            },
        });
    }
    // 访客拒绝邀请cgi
    function refuseInvite(data) {
        const { kfuin } = data;
        const { aid } = globalVars.wpaDetail.WPA_LOGIN_CONFIG;
        $.ajax({
            url: `${COMP_CONF.CGI_URL.refuseInvite}`,
            data: JSON.stringify({
                kfuin,
                visitorId: aid
            }),
            type: 'POST',
            timeout: 5000,
            dataType: 'json',
            contentType: 'application/json;charset=UTF-8',
            success: function (res) {
                if (res.code === 0) ;
            },
            error: function (err) {
                console.log('err 拒绝邀请接口报错', err);
            },
        });
    }
    // wpa aid和webim aid进行绑定
    function bindWpaAndImAid(data) {
        const { kfuin, webimAid, wpaId } = data;
        const { aid } = globalVars.wpaDetail.WPA_LOGIN_CONFIG;
        const params = JSON.stringify({
            kfuin,
            webimAid,
            wpaAid: aid,
            wpaId
        });
        $.ajax({
            url: `${COMP_CONF.CGI_URL.bindWpaAndImAid}`,
            data: params,
            type: 'POST',
            timeout: 5000,
            dataType: 'json',
            contentType: 'application/json;charset=UTF-8',
            success: function (res) {
                rumReport({
                    message: `imwpa:访客把wpa aid和webim aid进行绑定-params=${params}-result=${JSON.stringify(res)}`,
                    kfuin: kfuin,
                });
                if (res.code === 0) ;
            },
            error: function (err) {
                rumReport({
                    message: `imwpa:访客把wpa aid和webim aid进行绑定失败-params=${params}-err=${JSON.stringify(err)}`,
                    kfuin: kfuin,
                });
                console.log('err 绑定aid接口报错', err);
            },
        });
    }
    // 获取socket登录配置
    function socketLoginConfig(obj) {
        const wpa = JSON.parse(JSON.stringify(obj));
        const { kfuin, WPA_LOGIN_CONFIG } = wpa;
        // mango登录需要aid
        const aid = WPA_LOGIN_CONFIG.aid;
        const d2 = WPA_LOGIN_CONFIG.d2 || '';
        if(!!wpa.WPA_LOGIN_CONFIG.auth) {
            initInstant(wpa);
            return ;
        }
        let postData = {
            uint64_kfuin: kfuin,
            uint32_appid: COMP_CONF.appid,
            str_useragent: navigator.userAgent || '',
            // C侧请求使用的用户key。server根据这个值来确定C侧用户的aid
            // 如果有保存，则返回。否则发送空字符串。
            // 如果有 auth认证， 也传空
            bytes_custom_key: encode(String(aid)),
            str_session_ticket: d2,
            str_client_uuid: '',
        };
        if (!d2) {
            // wpa生成一定会有
            postData.str_client_uuid = WPA_LOGIN_CONFIG.uuid;
        }
        $.ajax({
            url: `${COMP_CONF.CGI_URL.socketLoginConfig}`,
            data: JSON.stringify(postData),
            type: 'POST',
            timeout: 5000,
            dataType: 'json',
            contentType: 'application/json;charset=UTF-8',
            success: function (res) {
                const { code, data } = res;
                if (code === 0 && data) {
                    const aid = data.uint64_unique_id;
                    const d2 = decode(data.session_ticket || '');
                    // 鉴权信息
                    const userInfo = data.bytes_str_user_info;
                    if (!aid || !d2) {
                        console.log('data error');
                        return;
                    }
                    const loginConfig = globalVars.wpaDetail.WPA_LOGIN_CONFIG = {
                        aid,
                        d2,
                        userInfo,
                        uuid: postData.str_client_uuid
                    };
                    // 此处通知更新WPA。
                    window.parent.postMessage({
                        act: 'UPDATE_AUTH',
                        data: {
                            visitorid: loginConfig.aid,
                            wpatoken: loginConfig.d2,
                            uuid: postData.str_client_uuid,
                            kfuin,
                        },
                    }, '*');

                    if (wpa.isWpaMangoWssOpt) {
                        if (!wpa.isLinkWPA) {
                            autotInviteConf(globalVars.wpaDetail, function(res) {
                                const manualInvite = res.manualInviteSwitch;
                                // 1. 开启了手动邀请会话 1--开启 2--关闭
                                // 2. 点击过wpa 并且在7天有效期内 用于接收离线消息
                                // 3. 配置了消息外显
                                if (Number(manualInvite) === 1
                                    || (wpa.clickedExpiry && Date.now() < wpa.clickedExpiry)
                                    || wpa.msgDisplayed)
                                {
                                    initInstant(wpa);
                                }
                            });
                        } else {
                            // 1. 配置了消息外显
                            // 2. 点击过wpa 并且在7天有效期内 用于接收离线消息
                            if (wpa.msgDisplayed
                                || (wpa.clickedExpiry && Date.now() < wpa.clickedExpiry)
                            ) {
                                initInstant(wpa);
                            }
                        }
                    } else {
                        // 如果不在白名单内 则保持原逻辑
                        initInstant(wpa);
                    }
                } else if (code === 10017 || code === 600017) {
                    // 只有匿名登录的时候需要同步删除aid和d2,
                    globalVars.wpaDetail.WPA_LOGIN_CONFIG = {
                        aid: createRandomId(),
                        d2: '',
                        uuid: createUuid32()
                    };
                    // eslint-disable-next-line no-param-reassign
                    maxReTryTime -= 1;
                    // 每次请求有3次重试的机会
                    if (maxReTryTime > 0) {
                        socketLoginConfig(globalVars.wpaDetail);
                    }
                } else {
                    rumReport({
                        message: `imwpa:访客获取instant初始化参数失败-params=${JSON.stringify(postData)}-err=${JSON.stringify(res)}`,
                        kfuin: kfuin,
                    });
                }        },
            error: function (err) {
                rumReport({
                    message: `imwpa:访客获取instant初始化参数失败-err=${JSON.stringify(err)}`,
                    kfuin: kfuin,
                });
               console.log(err);
            },
        });
    }

    /**
     * isMobile.js v0.4.1
     *
     * A simple library to detect Apple phones and tablets,
     * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
     * and any kind of seven inch device, via user agent sniffing.
     *
     * @author: Kai Mallea (kmallea@gmail.com)
     *
     * @license: http://creativecommons.org/publicdomain/zero/1.0/
     */
    (function (global) {

        var apple_phone         = /iPhone/i,
            apple_ipod          = /iPod/i,
            apple_tablet        = /iPad/i,
            android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
            android_tablet      = /Android/i,
            amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
            amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
            windows_phone       = /Windows Phone/i,
            windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
            other_blackberry    = /BlackBerry/i,
            other_blackberry_10 = /BB10/i,
            other_opera         = /Opera Mini/i,
            other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
            other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
            seven_inch = new RegExp(
                '(?:' +         // Non-capturing group

                'Nexus 7' +     // Nexus 7

                '|' +           // OR

                'BNTV250' +     // B&N Nook Tablet 7 inch

                '|' +           // OR

                'Kindle Fire' + // Kindle Fire

                '|' +           // OR

                'Silk' +        // Kindle Fire, Silk Accelerated

                '|' +           // OR

                'GT-P1000' +    // Galaxy Tab 7 inch

                ')',            // End non-capturing group

                'i');           // Case-insensitive matching

        var match = function(regex, userAgent) {
            return regex.test(userAgent);
        };

        var IsMobileClass = function(userAgent) {
            var ua = userAgent || navigator.userAgent;

            // Facebook mobile app's integrated browser adds a bunch of strings that
            // match everything. Strip it out if it exists.
            var tmp = ua.split('[FBAN');
            if (typeof tmp[1] !== 'undefined') {
                ua = tmp[0];
            }

            // Twitter mobile app's integrated browser on iPad adds a "Twitter for
            // iPhone" string. Same probable happens on other tablet platforms.
            // This will confuse detection so strip it out if it exists.
            tmp = ua.split('Twitter');
            if (typeof tmp[1] !== 'undefined') {
                ua = tmp[0];
            }

            this.apple = {
                phone:  match(apple_phone, ua),
                ipod:   match(apple_ipod, ua),
                tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
                device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
            };
            this.amazon = {
                phone:  match(amazon_phone, ua),
                tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
                device: match(amazon_phone, ua) || match(amazon_tablet, ua)
            };
            this.android = {
                phone:  match(amazon_phone, ua) || match(android_phone, ua),
                tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
                device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
            };
            this.windows = {
                phone:  match(windows_phone, ua),
                tablet: match(windows_tablet, ua),
                device: match(windows_phone, ua) || match(windows_tablet, ua)
            };
            this.other = {
                blackberry:   match(other_blackberry, ua),
                blackberry10: match(other_blackberry_10, ua),
                opera:        match(other_opera, ua),
                firefox:      match(other_firefox, ua),
                chrome:       match(other_chrome, ua),
                device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
            };
            this.seven_inch = match(seven_inch, ua);
            this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

            // excludes 'other' devices and ipods, targeting touchscreen phones
            this.phone = this.apple.phone || this.android.phone || this.windows.phone;

            // excludes 7 inch devices, classifying as phone or tablet is left to the user
            this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

            if (typeof window === 'undefined') {
                return this;
            }
        };

        var instantiate = function() {
            var IM = new IsMobileClass();
            IM.Class = IsMobileClass;
            return IM;
        };

        global.isMobile = instantiate();

    })(window);

    __domain || {chat: "chat.qidian.qq.com"};

    var StatusManager = function (window) {
        var wpaDetail = {};
        getVisitorId();

        /**
         * 是否为链接型WPA
         */
        var isLinkWPA = function () {
            var pageURL = window.location.href,
                isLinkWPA = getUrlQuery(pageURL, 'linkType'),
                visitorId = getUrlQuery(pageURL, 'visitorId'),
                isInIframe = window.parent == window ? false : true;
            visitorId && visitorId.length > 0 ? isLinkWPA = 1 : ''; //兼容呼起手Q中转页网页咨询传递的参数
            if (isLinkWPA && (''+isLinkWPA).length > 0 && !isInIframe) {
                return true;
            }
            return false;
        }();

        /**
         * 页面可见时，如果在线/离线socket连接断开后，需要重新连接
         */
        var pageV = pageVisibility();
        pageV.isPageVisibilitySupport && pageV.visibilitychange(function(event, isHidden, visibilityState) {
          setTimeout(function () {
          }, 500);
        });

        function postMsgListener(msgData) {
            if(typeof msgData === 'undefined') return;
            window['qd_qid_for_rpt'] = msgData['qid'] || '';
            if (msgData['__QIDIAN_WPA_VISITORID_FOR_RPT']) {
                window['__QIDIAN_WPA_VISITORID_FOR_RPT'] = msgData['__QIDIAN_WPA_VISITORID_FOR_RPT'];
            }
            var act = msgData.act;
            switch (act) {
                case 'SM_INIT':
                    if (!wpaDetail || wpaDetail.kfuin != msgData.kfuin) {
                        msgData.kfuin = Number(msgData.kfuin);
                        msgData.wpaId = Number(msgData.wpaId) || '';
                        wpaDetail = msgData;
                        wpaDetail.linkType = (msgData.linkType ? 1 : 0);
                        globalVars.wpaDetail = wpaDetail;
                        if (wpaDetail.isWpaMangoWssOpt) {
                            wpaDetail.isLinkWPA = isLinkWPA;
                            socketLoginConfig(wpaDetail);
                        } else {
                            socketLoginConfig(wpaDetail);
                            !isLinkWPA && autotInviteConf(globalVars.wpaDetail);
                        }
                    } else {
                        return;
                    }
                    break;
                case 'SM_REFUSE':
                    // 拒绝邀请
                    refuseInvite(msgData);
                    break;
                case 'SMS_SM_FORCE_CONNECT':
                    break;
                case 'SM_INVITE_RET':
                    break;
                case 'SM_BIND_WPA_IM_AID':
                    if(wpaDetail.kfuin == msgData.kfuin && wpaDetail.wpaId == msgData.wpaId) {
                        bindWpaAndImAid(msgData);
                    }
            }
        }
        function createSocket(type) {
            postMsgSender({
                act: 'SM_READY',
                kfuin: getUrlQuery(location.href, 'kfuin')
            });
            // isLinkWPA ? prepareWPADetail() : '';
            // socket.ioLink.once('reconnect', function() {
            //     // log('socket reconnect');
            //     onLineNoticeBatch();
            // });
            // //断开之后马上通知会话链接
            // socket.ioLink.once('disconnect', function(reason) {
            //     if (reason === 'transport close') {
            //       postMsgSender({
            //           act: 'DISCONNECT'
            //       });
            //     }
            // });
        }

        function forceConnect() {
            // mango会自己重连
            // if (socket.ioLink && socket.ioLink.disconnected) {
            //     createSocket('reconnect'); //   判断在线离线状态再决定是否重建
            // }
        }
        return {
            start: function() {
                if(window.CURRENT_VISITORID) {
                    window.CURRENT_VISITORID;
                }
                createSocket();
                postMsg.receive(window, postMsgListener);
                //自测
                // setTimeout(function() {
                //     socket.ioLink.disconnect();
                //     log('socket disconnect');
                // }, 5000);
            },
            forceConnect: forceConnect
        };
    }(window);
    window.__STATUS_MANAGER = StatusManager;
    StatusManager.start();

})();
